<template>
  <main-layout :selectedMenu="'home'">
    <div class="container containerMatchUpVideo" v-if="first">
      <div class="no-identificaton">
        <button
          class="upload-button"
          :disabled="!checked"
          :class="{'disable-button': !checked}"
          @click="gotoContent"
        >{{$t('global.上传视频')}}</button>
        <div class="support">
          {{$t('global.支持格式')}} flv,mpg,mpeg,avi,wmv,mov,asf,rm,rmvb,mkv,mp4
          <br />
          {{$t('global.文件大小限制')}}，{{$t('global.3G以内')}}
          <br />
          {{$t('global.上传视频，即表示您已同意MANA上传服务条款，请勿上传色情，反动等违法视频')}}
        </div>
        <div class="Protocol">
          <el-checkbox v-model="checked">
            {{$t('global.并同意遵守')}}
            <router-link tag="span" to="/about/用户协议">《{{$t('global.MANA原创/授权视频声明用户规范')}}》</router-link>、
            <router-link tag="span" to="/about/免责声明">{{$t('global.《MANA法律责任》')}}</router-link>
          </el-checkbox>
        </div>
        <div class="help-top">{{$t('global.帮助说明')}}</div>
        <div class="top-choose">
          <router-link tag="div" to="/about/投稿须知" class="hmessage">{{$t('global.投稿须知')}}</router-link>
          <span>|</span>
          <router-link tag="div" to="/about/常见问题" class="hmessage">{{$t('global.常见问题')}}</router-link>
        </div>
      </div>
    </div>
    <input type="file" class="upInput" accept="video/*" @change="upVideo" />
    <service></service>
    <div class="containerSwcond" v-if="second">
      <div class="progress-wrap" v-if="search.indexOf('edit') <= 0">
        <div class="progress-head">
          <div class="left">{{fileName}}</div>
          <div class="right" v-if="!$query.edit">
            {{$t('global.视频正在上传')}}
            <span ref="proNumber"></span>
          </div>
        </div>
        <div class="progress">
          <div class="p-top" ref="progress"></div>
        </div>
      </div>
      <div class="basic-wrap">
        <div class="alHead">{{$t('global.视频基本信息')}}</div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.视频名称')}}</div>
            <input
              type="text"
              class="real-name"
              :placeholder="$t('global.请输入作品名字')"
              v-model="title"
            />
          </div>
          <div class="right">
            <div class="font">
              {{$t('global.作品类型')}}
              <span
                class="tips"
              >（* {{$t('global.原创标签需要')}} {{$t('global.认证')}} {{$t('global.后进行设置')}}）</span>
            </div>
            <select v-model="isOriginal" @change="chagneOriginal">
              <option value="1">{{$t('global.原创')}}</option>
              <option value="2">{{$t('global.非原创')}}</option>
            </select>
            <!--<input type="text" class="choose">-->
          </div>
        </div>
        <div class="contain">
          <div class="left">
            <div class="font">{{$t('global.视频简介')}}</div>
            <textarea id="peopleDT" :placeholder="$t('global.请输入作品简介')" v-model="introduction"></textarea>
          </div>
          <div class="right">
            <div class="font">{{$t('global.其他创作者')}}</div>
            <el-select
              v-model="chooseNmae"
              filterable
              remote
              :remote-method="searchUser"
              :placeholder="$t('global.请选择')"
              class="elselect"
            >
              <el-option
                v-for="(item,index) in fanlist.slice(0,9)"
                :key="index"
                :value="item.nickname"
              >
                <div @click="addOtherCreater(index)">
                  <img :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)" class="fanHead" />
                  {{item.nickname}}
                </div>
              </el-option>
            </el-select>
            <div class="otherCreaterStyle">
              <div class="otherCitem" v-for="(item,index) in otherCreaterArr" :key="index">
                <img :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)" class="fanHead" />
                {{item.nickname}}
                <span
                  @click="deleteOtherCreater(index)"
                  class="deleteOC"
                >{{$t('global.删除')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="upload-wrap">
        <div class="up-head">
          {{$t('global.上传封面')}}
          <span>{{$t('global.上传图片请控制在3M以内,上传图片比例为16:9')}}</span>
        </div>
        <div class="bline"></div>
        <div class="upcontent">
          <div class="upload" :style="thumb | bgImageUrl">
            <div class="add-wrap" @click="upImgClick(1)" :class="{'add-wrap-active': thumb != ''}">
              <template v-if="thumb == ''">
                <img src="/static/uploadvideo/add.png" alt class="add" />
                <div class="font">{{$t('global.请上传作品封面')}}</div>
              </template>
            </div>
          </div>
          <div class="up-head">
            {{$t('global.上传图片')}}
            <span>{{$t('global.上传图片请控制在3M以内,上传图片比例为16:9')}}</span>
          </div>
          <div class="bline"></div>
          <div class="upcontent1">
            <div
              class="upload"
              v-for="(item,index) in images"
              :key="index"
              :style="item | bgImageUrl"
            ></div>
            <div class="upload">
              <div class="add-wrap" @click="upImgClick(2)">
                <img src="/static/uploadvideo/add.png" alt class="add" />
                <div class="font">{{$t('global.请上传图片')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="addLabel">
        <div class="alHead">
          {{$t('global.添加标签')}}
          <span>{{$t('global.添加标签可以把作品自动推荐给可能感兴趣的人')}}</span>
        </div>
        <div class="contain">
          <div class="left">
            <input type="text" :placeholder="$t('global.请输入标签')" v-model="productLable" />
            <span class="stick" @click="addLable">{{$t('global.贴标签')}}</span>
          </div>
          <div class="right"></div>
        </div>
        <div class="choose-label">
          <div class="label" v-for="(item,index) in selectedFilters" :key="index">
            <div class="font">{{item}}</div>
            <div class="close" @click="deleteLable(index)">
              <img src="/static/uploadvideo/close.png" alt />
            </div>
            <span>|</span>
          </div>
        </div>
        <div class="hot-label">
          <div class="title">{{$t('global.热门标签')}}：</div>
          <div class="choose-label">
            <div
              class="label"
              v-for="(item,index) in hotTagList"
              :key="index"
              @click="addHotTitle(index)"
            >
              <div class="font">{{item.title}}</div>
              <div class="close">
                <img src="/static/uploadvideo/close.png" alt />
              </div>
              <span>|</span>
            </div>
          </div>
        </div>
      </div>
      <div class="choose-subject">
        <div class="alHead">
          {{$t('global.选择行业和专业')}}
          <span>{{$t('global.可以把作品自动归类到对应的行业和专业')}}</span>
        </div>
        <div class="subject">
          <div class="sub-head">{{$t('global.专业')}}</div>
          <el-checkbox
            v-model="professionIds"
            v-for="(item ,index) in professionList"
            :key="index"
            :label="item.categoryId"
            style="display:inline-block;padding-top: 0.3rem"
          >{{item.title}}</el-checkbox>
        </div>
        <div class="industry">
          <div class="sub-head">{{$t('global.行业')}}</div>
          <el-checkbox
            v-model="industryIds"
            v-for="(item ,index) in industryList"
            :key="index"
            :label="item.categoryId"
            style="display:inline-block;padding-top: 0.3rem"
          >{{item.title}}</el-checkbox>
        </div>
      </div>
      <div class="moreMessage">
        <div class="alHead">{{$t('global.更多信息设置')}}</div>
        <div class="message-set">
          <div class="radio-wrap" v-if="isOriginal != '2'">
            <div class="radio-head">{{$t('global.作品是否允许被下载')}}：</div>
            <div class="radio-cho">
              <el-radio v-model="allowDownload" :label="1">{{$t('global.是')}}</el-radio>
              <el-radio v-model="allowDownload" :label="2">{{$t('global.否')}}</el-radio>
            </div>
          </div>
          <div class="contain">
            <div class="left">
              <div class="font">{{$t('global.制作软件')}}：</div>
              <input type="text" :placeholder="$t('global.请输入装备标签')" v-model="equipmentLable" />
              <span class="stick" @click="addEquipment">{{$t('global.贴标签')}}</span>
            </div>
            <div class="right"></div>
          </div>
          <div class="choose-label">
            <div class="label" v-for="(item,index) in equipment" :key="index">
              <div class="font">{{item}}</div>
              <div class="close" @click="deleteEquipment">
                <img src="/static/uploadvideo/close.png" alt />
              </div>
              <span>|</span>
            </div>
          </div>
          <div class="contain">
            <div class="left">
              <div class="font">{{$t('global.投稿至比赛')}}：</div>
              <select v-model="activityId">
                <option value>{{$t('global.不投稿')}}</option>
                <option
                  v-for="item of competitionList"
                  :value="item.activityId"
                  :key="item.activityId"
                >{{item.title}}</option>
              </select>
            </div>
            <div class="right"></div>
          </div>
        </div>
      </div>

      <div class="operate-btn">
        <div class="publish" @click="createUpVideo(1)">{{$t('global.发布')}}</div>
        <div class="review" @click="createUpVideo(0)">{{$t('global.预览')}}</div>
      </div>
      <input
        type="file"
        class="upInputIMG"
        accept="image/*"
        @change="upImg"
      />
      <input
        type="file"
        class="upInputIMG1"
        accept="image/*"
        @change="upImg"
      />
    </div>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import * as qiniu from "qiniu-js";

export default {
  name: "MatchUpVideo",
  metaInfo() {
    return {
      title: this.$t("global.上传视频") + " | MANA"
    };
  },
  data() {
    return {
      isIden: "",
      checkList: [],
      checkList1: [],
      fileName: "",
      checked: true,
      contentIndex: 1,
      first: true,
      second: false,
      selectedFilters: [],
      hotTagList: [],
      industryList: [],
      professionList: [],
      productLable: "",
      equipmentLable: "",
      fanlist: [],
      title: "",
      hash: "",
      key: "",
      thumb: "",
      images: [],
      introduction: "",
      isOriginal: "2",
      allowDownload: 2,
      equipment: [],
      activityId: "",
      industryIds: [],
      professionIds: [],
      competitionList: [],
      videoId: "",
      creatorIds: [],
      chooseNmae: "",
      otherCreaterArr: [],
      search: "",
      token: ""
    };
  },
  components: {
    MainLayout,
    service
  },
  computed: {
    getProgress() {
      return this.progress;
    }
  },
  created() {
    this.hotTagListF();
    this.categoryList();
    this.getOtherCreator();
    this.competition();
    this.isIdentification();
    if (this.$query.edit) {
      this.first = false;
      this.second = true;
      this.videoId = this.$query.videoId;
    }
    this.search = window.location.search;
  },
  watch: {
    $route(to, from) {
      if (!this.$query.edit) {
        this.init();
      }
      this.search = window.location.search;
    },
    fileName(val) {
      if (this.title) {
      } else {
        this.title = val;
      }
    },
    isOriginal(val) {
      if (!this.isIden) {
        this.isOriginal = "2";
        this.$router.push("/ApplyIdentification");
        // this.$message("Please conduct personal certification first");
      }
    }
  },
  methods: {
    searchUser(query) {
      if (query !== "") {
        this.get_searchUser(query);
      } else {
        this.fanlist = [];
      }
    },
    get_searchUser(query) {
      const _this = this;
      this.$http
        .post("/api/search/list", {
          keyword: query,
          type: 2,
          pageIndex: 1,
          pageSize: 20
        })
        .then(function(response) {
          if (
            response.data &&
            response.data.pageList &&
            response.data.pageList.list
          ) {
            const userList = filter_user(response.data.pageList.list);
            _this.fanlist = userList;
          }
        });
      function filter_user(list) {
        let userList = [];
        for (let i = 0; i < list.length; i++) {
          const el = list[i];
          const userDetail = {
            avatar: el.avatar,
            creatorId: el.userId,
            nickname: el.nickname
          };
          userList.push(userDetail);
        }
        return userList;
      }
    },
    init() {
      this.first = true;
      this.second = false;
      this.videoId = "";
      this.selectedFilters = "";
      this.creatorIds = "";
      this.title = "";
      this.introduction = "";
      this.thumb = "";
      this.images = "";
      this.allowDownload = 2;
      this.isOriginal = "2";
      this.equipment = "";
      this.hash = "";
      this.activityId = "";
      this.industryIds = "";
      this.professionIds = "";
      this.key = "";
      this.fileName = "";
    },
    hotTagListF() {
      this.$http.get("/api/common/hotTagList").then(response => {
        this.hotTagList = response.data;
      });
    },
    categoryList() {
      this.$http.get("/api/common/categoryList").then(response => {
        this.industryList = response.data.industryList;
        this.professionList = response.data.professionList;
      });
    },
    addLable() {
      var $this = this;
      if (this.productLable == "") {
        this.$message.error(this.$t("global.标签内容不能为空"));
      } else {
        if (this.selectedFilters.length < 10) {
          for (let i = 0; i < $this.selectedFilters.length; i++) {
            if ($this.productLable == $this.selectedFilters[i]) {
              $this.$message.error(this.$t("global.标签内容不能重复"));
              return;
            }
          }
          this.selectedFilters.push(this.productLable);
          this.productLable = "";
        } else {
          this.$message.error(this.$t("global.标签个数超过上限"));
        }
      }
    },
    deleteLable(index) {
      this.selectedFilters.splice(index, 1);
    },
    addEquipment() {
      var $this = this;
      if (this.equipmentLable == "") {
        this.$message.error(this.$t("global.标签内容不能为空"));
      } else {
        if (this.equipment.length < 10) {
          for (let i = 0; i < $this.equipment.length; i++) {
            if ($this.equipmentLable == $this.equipment[i]) {
              $this.$message.error(this.$t("global.标签内容不能重复"));
              return;
            }
          }
          this.equipment.push(this.equipmentLable);
          this.equipmentLable = "";
        } else {
          this.$message.error(this.$t("global.标签个数超过上限"));
        }
      }
    },
    deleteEquipment(index) {
      this.equipment.splice(index, 1);
    },
    addHotTitle(index) {
      let tag = this.hotTagList[index];
      if (!this.selectedFilters.find(n => n === tag)) {
        this.selectedFilters.push(tag.title);
      } else {
        this.$message(this.$t("global.不可重复添加"));
      }
    },
    changeIndex(index) {
      this.contentIndex = index;
    },
    gotoContent() {
      if (this.$store.state.peopleMessage.email.length > 3) {
        document.querySelector(".upInput").click();
      } else {
        this.$router.push("/manageCenter");
      }
    },
    upImgClick(index) {
      this.$store.dispatch("setImgIndex", index);
      if (index === 1) {
        document.querySelector(".upInputIMG").click();
      } else {
        document.querySelector(".upInputIMG1").click();
      }
    },
    isIdentification() {
      this.$http.get("/api/u/certification/check").then(response => {
        this.isIden = response.data;
        if (!this.isIden) {
          this.isOriginal = "2";
        }
      });
    },
    chagneOriginal() {},
    addOtherCreater(index) {
      this.creatorIds.push(this.fanlist[index].creatorId);
      this.otherCreaterArr.push(this.fanlist[index]);
    },
    deleteOtherCreater(index) {
      this.creatorIds.splice(index, 1);
      this.otherCreaterArr.splice(index, 1);
    },
    upVideo(e) {
      var $this = this;
      this.first = false;
      this.second = true;
      this.fileName = e.target.files[0].name;
      if (e.target.files[0].size / 1024 / 1024 > 3072) {
        this.$message.info(this.$t("global.文件不能大于3G"));
        return;
      }
      var observable;
      var subscription;
      var error = function(err) {
        $this.$refs.proNumber.parentNode.innerHTML = this.$t("global.上传失败");
      };

      var complete = function(res) {
        $this.$refs.proNumber.parentNode.innerHTML = this.$t("global.上传成功");
        $this.hash = res.hash;
        $this.key = res.key;
        let thumb = `https://video.manamana.net/${$this.key}?vframe/jpg/offset/1/w/300/h/300`;
        $this.thumb = thumb;
      };

      var next = function(response) {
        var total = response.total;
        $this.$refs.progress.style.width = parseInt(total.percent) + "%";
        $this.$refs.proNumber.innerHTML = `${$this.$t(
          "global.已上传"
        )}${Math.round(total.percent * 100) / 100}%`;
      };

      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null
      };
      var putExtra = {
        fname: $this.fileName.split(".")[0],
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/token/video").then(res => {
        this.token = res.data;
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + this.fileName,
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    upImg(e) {
      if (e.target.files[0].size / 1024 / 1024 > 3) {
        this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
        return;
      }
      let param = new FormData();
      param.append("files", e.target.files[0]);
      this.$http
        .post("/api/common/upload/image", param, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.$message({
            message: response.message,
            type: "success"
          });
          switch (this.$store.state.imgIndex) {
            case 1:
              this.thumb = response.data;
              break;
            case 2:
              this.images.push(response.data);
              break;
          }
        });
    },
    getOtherCreator() {
      let config = {
        loading: false
      };
      this.$http.get("/api/u/video/otherCreator", config).then(response => {
        this.fanlist = response.data;
        if (this.$query.edit) {
          this.detail(this.videoId);
        }
      });
    },
    testValue(envent, valueS) {
      let reg = /\S/;
      if (!this.title) {
        this.$message.error(this.$t("global.视频名称不能为空"));
        return false;
      }
      if (!this.isOriginal) {
        this.$message.error(this.$t("global.请选择是否原创"));
        return false;
      }
      if (!this.introduction) {
        this.$message.error(this.$t("global.视频简介不能为空"));
        return false;
      }
      if (!this.thumb) {
        this.$message.error(this.$t("global.请上传作品封面"));
        return false;
      }
      if (!this.images) {
        this.$message.error(this.$t("global.请上传作品图片"));
        return false;
      }
      if (!this.industryIds) {
        this.$message.error(this.$t("global.请选择行业"));
        return false;
      }
      if (!this.professionIds) {
        this.$message.error(this.$t("global.请选择专业"));
        return false;
      }
      if (!this.allowDownload) {
        this.$message.error(this.$t("global.请选择是否允许被下载"));
        return false;
      }
    },
    createUpVideo(statusNumber) {
      let testResult = this.testValue();
      if (testResult === false) return;
      let url = "/api/match/user/createVideo";
      if (this.videoId !== "") {
        url = "/api/u/video/update";
      }

      this.$http
        .post(url, {
          tags: this.selectedFilters.join(),
          creatorIds: this.creatorIds.join(),
          videoId: this.videoId,
          title: this.title,
          introduction: this.introduction,
          thumb: this.thumb,
          images: this.images.join(),
          allowDownload: this.allowDownload,
          isOriginal: this.isOriginal,
          equipment: this.equipment.join(),
          hash: this.hash,
          key: this.key,
          activityId: this.activityId,
          status: statusNumber,
          industryIds: this.industryIds,
          professionIds: this.professionIds,
          fileName: this.fileName,
          matchId: this.$query.matchId
        })
        .then(response => {
          if (response.code === "OK") {
            if (!this.$query.edit) {
              this.videoId = response.data;
            }
            if (statusNumber === 0) {
              let routeData = this.$router.resolve({
                path: "video/detail",
                query: { id: this.videoId }
              });
              let newWindow = window.open("", "_blank");
              newWindow.location = routeData.href;
            } else {
              this.$message.success(
                `${this.$t("global.上传成功")}，${this.$t("global.请等待审核")}`
              );
              this.$router.push("/manageVideo");
            }
          }
        });
    },
    competition() {
      this.$http.get("/api/u/video/activityList").then(response => {
        if (response.data.length > 0) {
          this.competitionList = response.data;
        }
      });
    },
    detail(id) {
      this.$http.get("/api/u/video/detail/" + id).then(response => {
        let data = response.data;
        this.selectedFilters = data.tagList;
        this.creatorIds = data.creatorIdList;
        this.title = data.title;
        this.introduction = data.introduction;
        this.thumb = data.thumb;
        this.images = data.images != "" ? data.images.split(",") : [];
        this.allowDownload = data.allowDownload ? data.allowDownload : 2;
        this.isOriginal = data.isOriginal;
        this.equipment = data.equipment != "" ? data.equipment.split(",") : [];
        this.hash = data.hash;
        this.activityId = data.id;
        this.industryIds = data.industryIdList;
        this.professionIds = data.professionIdList;
        this.key = data.key;
        this.fileName = data.fileName;
        for (let i = 0; i < this.creatorIds.length; i++) {
          for (let j = 0; j < this.fanlist.length; j++) {
            if (this.creatorIds[i] === this.fanlist[j].creatorId) {
              this.otherCreaterArr.push(this.fanlist[j]);
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.otherCreaterStyle {
  height: 1.6rem;
  overflow: auto;

  .otherCitem {
    margin-top: 0.06rem;
  }

  .deleteOC {
    display: inline-block;
    padding: 0.06rem 0.1rem;
    border-radius: 0.06rem;
    color: #ffffff;
    background-color: #d5d5d5;
  }
}

.fanHead {
  width: 0.32rem;
  height: 0.32rem;
  margin: -0.02rem 0.1rem 0 0;
}

.upInput, .upInputIMG, .upInputIMG1 {
  display: none;
}

.containerSwcond {
  width: 18rem;
  margin: 0.4rem auto;

  .operate-btn {
    display: flex;
    padding: 0.8rem 5.57rem 0;
    justify-content: space-between;
    line-height: 0.46rem;
    text-align: center;
    font-size: 0.18rem;

    .publish {
      cursor: pointer;
      width: 1.93rem;
      height: 0.46rem;
      background-color: #0161ff;
      border-radius: 0.23rem;
      color: #ffffff;
    }

    .review {
      cursor: pointer;
      width: 1.93rem;
      height: 0.46rem;
      /* background-color #bbbbbb */
      border-radius: 0.23rem;
      border: solid 1px #0161ff;
      color: #0161ff;
    }
  }

  .radio-wrap {
    display: flex;
    margin-top: 0.36rem;

    .radio-head {
      color: #000000;
      font-size: 0.18rem;
    }

    .radio-cho {
      margin-top: 0.01rem;
    }
  }

  .moreMessage {
    /* height 5.64rem */
    padding: 0 3rem 0.8rem;
    margin-top: 0.2rem;
    /* overflow hidden */
    background-color: #ffffff;
  }

  .industry {
    margin-top: 0.3rem;
  }

  .choose-subject {
    // height 5.22rem
    padding: 0 3rem 0.6rem;
    margin-top: 0.2rem;
    overflow: hidden;
    background-color: #ffffff;

    .sub-head {
      color: #000000;
      font-size: 0.18rem;
      padding-top: 0.3rem;
    }

    .sub-content {
      display: flex;
      flex-wrap: wrap;

      .sub-item {
        margin: 0.39rem 0.34rem 0 0;
        display: flex;

        .choose-item {
          width: 0.18rem;
          height: 0.18rem;
          background: url('/static/uploadvideo/chooseItem.png') no-repeat;
          background-size: 0.18rem 0.18rem;
        }

        .choose-con {
          font-size: 0.2rem;
          color: #000000;
          margin: -0.06rem 0 0 0.1rem;
        }
      }
    }
  }

  .hot-label {
    display: flex;
    color: #333333;
    font-size: 0.16rem;
    margin-top: 0.3rem;

    .title {
      padding-top: 0.3rem;
    }
  }

  .choose-label {
    display: flex;
    flex-wrap: wrap;

    .label {
      margin: 0.2rem 0.2rem 0 0;
      display: flex;
      /* width 1.4rem */
      height: 0.4rem;
      line-height: 0.4rem;
      background-color: #f9f9f9;
      border-radius: 0.2rem;
      border: solid 1px #dddddd;
      color: #999999;
      font-size: 0.18rem;
      position: relative;
      justify-content: space-between;

      .font {
        /* width 1.05rem */
        padding: 0 0.18rem;
        text-align: center;
      }

      span {
        position: absolute;
        right: 0.35rem;
      }

      .close {
        width: 0.35rem;
      }

      img {
        display: block;
        width: 0.1rem;
        height: 0.1rem;
        margin: 0.15rem auto;
      }
    }
  }

  .addLabel {
    padding: 0 3rem;
    margin-top: 0.2rem;
    overflow: hidden;
    background-color: #ffffff;
    padding-bottom: 0.3rem;
  }

  .stick {
    display: inline-block;
    margin-left: 0.3rem;
    width: 0.9rem;
    height: 0.3rem;
    background: #0060ff;
    color: #fff;
    border-radius: 4px;
    text-align: center;
    line-height: 0.3rem;
    cursor: pointer;
  }

  .alHead {
    padding: 0.42rem 0 0.32rem 0;
    font-size: 0.2rem;
    color: #000000;
    border-bottom: 1px solid #dddddd;

    span {
      color: #999999;
      font-size: 0.16rem;
    }
  }

  .upload {
    width: 3.8rem;
    height: 2.1rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.08rem;
    margin-top: 0.1rem;
    margin-right: 0.1rem;
    padding: 0.05rem;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  .add-wrap {
    width: 3.6rem;
    height: 1.9rem;
    margin: 0.1rem;
    border-radius: 0.08rem;
    border: dashed 2px #dddddd;
    cursor: pointer;

    .add {
      display: block;
      width: 0.8rem;
      height: 0.8rem;
      margin: 0.55rem auto 0.1rem;
    }

    .font {
      color: #333333;
      text-align: center;
      font-size: 0.22rem;
    }
  }

  .add-wrap-active {
    border: none;
  }

  .upload-wrap {
    /* height 6.32rem */
    padding: 0.6rem 3rem 1rem;
    margin-top: 0.2rem;
    /* overflow hidden */
    background-color: #ffffff;

    .up-head {
      color: #000000;
      font-size: 0.2rem;
      margin-top: 0.5rem;

      span {
        color: #999999;
        font-size: 0.16rem;
      }
    }

    .bline {
      width: 100%;
      height: 0.02rem;
      background: #dcdfe6;
      margin-top: 0.3rem;
    }

    .upcontent {
      /* display flex */
      padding-top: 0.32rem;
    }

    /* justify-content space-between */
    .upcontent1 {
      display: flex;
      flex-wrap: wrap;
      margin-top: 0.1rem;
    }

    .modify-btn {
      width: 1.55rem;
      height: 0.46rem;
      margin: 0.3rem 0.86rem 0;
      line-height: 0.46rem;
      font-size: 0.18rem;
      text-align: center;
      color: #0161ff;
      cursor: pointer;
      border-radius: 0.23rem;
      border: solid 1px #0161ff;
    }
  }

  .basic-wrap {
    height: 5.36rem;
    padding: 0 3rem;
    margin-top: 0.2rem;
    background-color: #ffffff;
  }

  .contain {
    display: flex;
    justify-content: space-between;
    margin-top: 0.32rem;

    .font {
      font-size: 0.16rem;
      height: 0.28rem;
      line-height: 0.28rem;
    }

    .tips {
      color: #999999;
      font-size: 0.16rem;
    }

    input, select, textarea {
      width: 4.5rem;
      height: 0.5rem;
      margin-top: 0.1rem;
      background-color: #F9F9F9;
      border-radius: 0.08rem;
      text-indent: 0.1rem;
      outline: none;
      border: none;
      font-size: 0.18rem;
    }

    #peopleDT {
      height: 2rem;
    }

    .special {
      display: flex;
      justify-content: space-between;
    }

    #area {
      display: block;
      width: 1.22rem;
    }

    .city {
      display: block;
      width: 3.08rem;
      margin-left: 0.2rem;
    }

    .resetW {
      width: 14.79rem;
    }
  }

  .progress-wrap {
    overflow: hidden;
    height: 1.58rem;
    background-color: #ffffff;

    .progress-head {
      display: flex;
      padding: 0 3rem;
      margin: 0.42rem auto 0;
      justify-content: space-between;

      .left {
        font-size: 0.2rem;
        color: #000000;
        font-weight: bold;
      }

      .right {
        font-size: 0.16rem;
        color: #707070;

        span {
          display: inline-block;
          margin-left: 0.3rem;
        }
      }
    }

    .progress {
      margin: 0.26rem 3rem 0;
      position: relative;
      height: 10px;
      background-color: #f9f9f9;
      border-radius: 0.05rem;
    }

    .p-top {
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 10px;
      background-color: #0161ff;
      border-radius: 0.05rem;
    }
  }
}

.no-identificaton {
  padding: 1.2rem 0;

  .help-top {
    color: #000000;
    font-size: 0.26rem;
    text-align: center;
    margin: 1rem auto 0;
  }

  .top-choose {
    display: flex;
    justify-content: center;
    margin-top: 0.3rem;
    font-size: 0.16rem;
    color: #333333;

    span {
      display: block;
      margin: 0 0.32rem;
    }
  }

  .Protocol {
    width: 5.78rem;
    display: flex;
    margin: 1rem auto 0;
    color: #707070;
    font-size: 0.16rem;

    img {
      width: 0.19rem;
      height: 0.19rem;
      margin: 0.02rem 0.08rem 0 0.22rem;
    }
  }

  .support {
    width: 5.78rem;
    margin: 0.6rem auto 0;
    line-height: 0.32rem;
    text-align: center;
    color: #333333;
    font-size: 0.16rem;
  }

  .tip {
    color: #ff0000;
    font-size: 0.16rem;
    margin-top: 0.3rem;
    text-align: center;
  }

  .upload-button {
    display: block;
    cursor: pointer;
    width: 3.8rem;
    height: 0.6rem;
    line-height: 0.6rem;
    color: #ffffff;
    font-size: 0.26rem;
    text-align: center;
    margin: 0 auto;
    background-color: #0161ff;
    border-radius: 0.08rem;
  }

  .disable-button {
    background-color: #5a5a5a;
    cursor: not-allowed;
  }
}

.container {
  margin: 0.6rem auto;
  background-color: #ffffff;
}

.hmessage {
  color: #409EFF;
  cursor: pointer;
}
</style>
<style>
.containerMatchUpVideo .el-input__inner {
  width: 4.5rem;
  height: 0.5rem;
  margin-top: 0.1rem;
  background-color: #f9f9f9;
  border-radius: 0.08rem;
  text-indent: 0.1rem;
  outline: none;
  border: none;
}

.containerMatchUpVideo .el-input__suffix-inner {
  position: relative;
  top: 0.06rem;
}
</style>
<style>
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #cecece;
}

input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #cecece;
}

input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #cecece;
}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #cecece;
}

.el-checkbox {
  min-width: 1.5rem;
  margin-right: 0.4rem;
}
.el-checkbox + .el-checkbox {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/video/MatchUpVideo.vue